import { render } from "./FooterFairGround.vue?vue&type=template&id=f1f662e0&scoped=true"
import script from "./FooterFairGround.vue?vue&type=script&lang=js"
export * from "./FooterFairGround.vue?vue&type=script&lang=js"

import "./FooterFairGround.vue?vue&type=style&index=0&id=f1f662e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f662e0"]])

export default __exports__